import { useState, useEffect } from "react";
import accessoriesAPI from "../data/accessories";

const useAccessories = ({ trimId: initTrimId }) => {
  const [accessories, setAccessories] = useState();
  const [trimId, setTrimId] = useState(initTrimId);

  useEffect(() => {
    const callAPI = async () => {
      try {
        const list = await accessoriesAPI(trimId);
        setAccessories(list);
      } catch (err) {
        setAccessories(err);
      }
    };

    if (trimId) {
      callAPI();
    }
  }, [trimId]);

  return [accessories, setTrimId];
};

export default useAccessories;
